"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuelConnector = exports.FUEL_BASE_GAS_LIMIT = void 0;
const axios_1 = __importDefault(require("axios"));
exports.FUEL_BASE_GAS_LIMIT = 500000000;
class FuelConnector {
    constructor(providerUrl) {
        this.providerUrl = providerUrl;
    }
    getGasLimit() {
        var _a;
        return !!((_a = this.providerUrl) === null || _a === void 0 ? void 0 : _a.indexOf("127.0.0.1")) ? 0 : exports.FUEL_BASE_GAS_LIMIT;
    }
    async getBlockNumber() {
        return Number((await this.getLatestBlock()).height);
    }
    async getLatestBlock() {
        const LATEST_BLOCK_QUERY = "query LatestBlockHeight { chain { latestBlock {  header { height, time } } } }";
        const response = await (0, axios_1.default)({
            url: this.providerUrl,
            method: "POST",
            data: { query: LATEST_BLOCK_QUERY },
        });
        return response.data.data.chain.latestBlock.header;
    }
}
exports.FuelConnector = FuelConnector;
//# sourceMappingURL=FuelConnector.js.map